<template>
	<div class="flex min-h-screen flex-col items-center justify-center bg-neutral-100 dark:bg-neutral-900">
		<div class="w-24 h-24 bg-white dark:bg-neutral-800 rounded-full flex items-center justify-center shadow-sm p-6">
			<LogoLoader />
		</div>
	</div>
</template>
